/**
 * RFST — Global theme behaviour
 * Mega-menu, mobile menu, sticky header, promo code copy.
 * Cart, product and filtering logic live in their own files.
 */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* -------------------------------------------------- *
   * Mega menu (desktop)
   * -------------------------------------------------- */

  var header = document.querySelector('[data-header]');

  function closeAllMegaMenus(except) {
    if (!header) return;
    header.querySelectorAll('.header-nav__link--toggle').forEach(function (toggle) {
      if (toggle === except) return;
      toggle.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = true;
        panel.classList.remove('is-open');
      }
    });
  }

  function openMegaMenu(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;

    closeAllMegaMenus(toggle);
    toggle.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    void panel.offsetWidth;
    panel.classList.add('is-open');
  }

  function closeMegaMenu(toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', 'false');
    if (panel) {
      panel.classList.remove('is-open');
      panel.hidden = true;
    }
  }

  if (header) {
    var hoverTimer = null;

    header.querySelectorAll('.header-nav__item--dropdown').forEach(function (item) {
      var toggle = item.querySelector('.header-nav__link--toggle');
      if (!toggle) return;

      // Pointer: open on hover with a small close delay so the panel is reachable.
      item.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        window.clearTimeout(hoverTimer);
        openMegaMenu(toggle);
      });

      item.addEventListener('mouseleave', function () {
        if (window.matchMedia('(hover: none)').matches) return;
        hoverTimer = window.setTimeout(function () {
          closeMegaMenu(toggle);
        }, 150);
      });

      // Keyboard & touch: toggle on click.
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          closeMegaMenu(toggle);
        } else {
          openMegaMenu(toggle);
        }
      });
    });

    // Close when focus leaves the nav entirely.
    header.addEventListener('focusout', function (event) {
      if (!header.contains(event.relatedTarget)) {
        closeAllMegaMenus();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllMegaMenus();
  });

  /* -------------------------------------------------- *
   * Mobile menu
   * -------------------------------------------------- */

  var mobileMenu = document.getElementById('MobileMenu');
  var mobileOverlay = document.querySelector('[data-mobile-menu-overlay]');

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.hidden = false;
    void mobileMenu.offsetWidth;
    mobileMenu.classList.add('is-open');
    if (mobileOverlay) mobileOverlay.hidden = false;
    document.body.classList.add('overflow-hidden');

    var toggle = document.querySelector('[data-mobile-menu-open]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');

    var close = mobileMenu.querySelector('[data-mobile-menu-close]');
    if (close) close.focus();
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    if (mobileOverlay) mobileOverlay.hidden = true;
    document.body.classList.remove('overflow-hidden');

    var toggle = document.querySelector('[data-mobile-menu-open]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');

    window.setTimeout(function () {
      if (!mobileMenu.classList.contains('is-open')) mobileMenu.hidden = true;
    }, 300);
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mobile-menu-open]')) {
      event.preventDefault();
      openMobileMenu();
    } else if (event.target.closest('[data-mobile-menu-close]') || event.target.closest('[data-mobile-menu-overlay]')) {
      event.preventDefault();
      closeMobileMenu();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMobileMenu();
  });

  /* -------------------------------------------------- *
   * Sticky header state
   * -------------------------------------------------- */

  if (header && header.classList.contains('site-header--sticky')) {
    var lastScroll = 0;

    window.addEventListener(
      'scroll',
      function () {
        var current = window.scrollY;
        header.classList.toggle('is-scrolled', current > 20);
        lastScroll = current;
      },
      { passive: true }
    );
  }

  /* -------------------------------------------------- *
   * Promo code copy
   * -------------------------------------------------- */

  document.addEventListener('click', function (event) {
    var copyButton = event.target.closest('[data-copy-code]');
    if (!copyButton || !navigator.clipboard) return;

    var code = copyButton.getAttribute('data-copy-code');
    var label = copyButton.querySelector('[data-copy-label]');
    var original = label ? label.textContent : '';

    navigator.clipboard
      .writeText(code)
      .then(function () {
        if (!label) return;
        label.textContent = window.RFSTStrings.copied;
        window.setTimeout(function () {
          label.textContent = original;
        }, 2000);
      })
      .catch(function () {});
  });
})();
